import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as CustomFieldsSelectors from './custom-fields.selectors';
import { Portals } from '@qwyk/models';
import * as CustomFieldsActions from './custom-fields.actions';

@Injectable()
export class CustomFieldsFacade {
    public loading$ = this.store.pipe(
        select(CustomFieldsSelectors.getCustomFieldsLoading)
    );
    public error$ = this.store.pipe(
        select(CustomFieldsSelectors.getCustomFieldsError)
    );
    public allCustomFields$ = this.store.pipe(
        select(CustomFieldsSelectors.getAllCustomFields)
    );

    constructor(private store: Store) {}

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public init(parent: Portals.ParentEntity, query: any): void {
        this.store.dispatch(CustomFieldsActions.init({ parent, query }));
    }
}
